
import './App.css';
import Main from './components/Main';
import './index.css'
function App() {
  return (
    <>
      <div className="main">

        <Main />
      </div>
    </>
  );
}

export default App;
